import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { TranslateService } from '@ngx-translate/core';
import { Config } from '../../services/config';
import { AwareHttpService } from '@appbolaget/aware-http';
import { Store } from '@ngxs/store';
import { ChangeApiLanguage } from 'app/state/app.actions';

@Injectable()
export class LanguageService {
    activeLanguage: any;
    activeApiLanguage: any;

    languages = [
        {
            title: 'LANGUAGES.SWEDISH',
            code: 'sv',
        },
        {
            title: 'LANGUAGES.ENGLISH',
            code: 'en',
        },
    ];

    apiLanguages = [
        {
            title: 'LANGUAGES.SWEDISH',
            code: 'sv',
        },
        {
            title: 'LANGUAGES.ENGLISH',
            code: 'en',
        },
        {
            title: 'LANGUAGES.ITALIAN',
            code: 'it',
        },
        {
            title: 'LANGUAGES.SLOVENIAN',
            code: 'sl',
        },
        {
            title: 'LANGUAGES.GERMAN',
            code: 'de',
        },
        {
            title: 'LANGUAGES.DUTCH',
            code: 'nl',
        },
        {
            title: 'LANGUAGES.DANISH',
            code: 'dk',
        },
    ];

    constructor(
        private storage: LocalStorageService,
        private translate: TranslateService,
        private config: Config,
        private api: AwareHttpService,
        private store: Store,
    ) {
        // ...
    }

    init() {
        let language = this.storage.retrieve('language');
        let apiLanguage = this.storage.retrieve('api_language');

        if (!language) {
            language = 'da';
        }

        this.translate.use(language);
        this.activeLanguage = language;

        if (!apiLanguage) {
            apiLanguage = 'da';
        }

        this.activeApiLanguage = apiLanguage;
        this.config.set('app.language', apiLanguage);

        this.api.setDefaultHeader('language', apiLanguage);
    }

    changeLanguage(language: string) {
        this.activeLanguage = language;

        this.translate.use(language);

        this.storage.store('language', language);
    }

    getTranslation(value: string, params = {}) {
        return this.translate.get(value, params).toPromise();
    }

    setApiLanguage(language: string) {
        this.activeApiLanguage = language;
        // this.config.set('app.language', language);

        this.storage.store('api_language', language);

        this.api.setDefaultHeader('language', language);

        this.store.dispatch(new ChangeApiLanguage());
    }

    public getCurrentLanguage(returnTranslated: boolean = true): string {
        for (const lang of this.languages) {
            if (this.activeLanguage === lang.code) {
                if (returnTranslated) {
                    return this.translate.instant(lang.title);
                }

                return lang.title;
            }
        }
    }

    public getCurrentApiLanguage(returnTranslated: boolean = true): string {
        for (const lang of this.apiLanguages) {
            if (this.activeApiLanguage === lang.code) {
                if (returnTranslated) {
                    return this.translate.instant(lang.title);
                }

                return lang.title;
            }
        }
    }
}
